import { render, staticRenderFns } from "./softwareDetail.vue?vue&type=template&id=560cb274&scoped=true&"
import script from "./softwareDetail.vue?vue&type=script&lang=js&"
export * from "./softwareDetail.vue?vue&type=script&lang=js&"
import style0 from "./softwareDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./softwareDetail.vue?vue&type=style&index=1&id=560cb274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560cb274",
  null
  
)

export default component.exports